module.exports = __webpack_public_path__ + "img/flfw_33.b9b6cd4b.png";